import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "public-api-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "public-api-settings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
